// @ts-check

import React from 'react';
// @ts-ignore: Cannot find module error
import error from '../../assets/img/error.png';

function PageNotAuthorized({ title }) {
  const header = title || 'User Not Authorized';

  return (
    <section className="container text-center">
      <h1 className="d-inline-block" data-testid="not-authorized">
        {header}
      </h1>
      <div>
        <img src={error} alt="" />
      </div>
      <div className="mt-3">
        <p>You do not have access to this application.</p>
        <p>
          Please review the{' '}
          <a
            href="https://docs.google.com/presentation/d/1QG1db1kCFo0E7DGTUcux2KEVfdoV1NomMPZYYmq2hak/edit?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            Campaign Builder Information Sheet
          </a>{' '}
          for the steps if you would like to request access.
        </p>
      </div>
    </section>
  );
}
export { PageNotAuthorized };
